import {
  ParentState,
  useCheckoutStateSelector as useSelector,
} from "@capone/checkout";
import { CheckoutStepperProps } from "halifax/build/CheckoutStepper/component";

import {
  ActivityAdditionalDetailsSelectors,
  ActivityTravelerSelectors,
} from "../../../../checkout";
import {
  isCheckoutImprovementsEnabled,
  useExperiments,
} from "../../../../context/experiments";

export const getCheckoutSteps = (
  parentState: ParentState
): CheckoutStepperProps["steps"] => {
  const hasAdditionalDetailsStep = useSelector(
    ActivityAdditionalDetailsSelectors.getHasAdditionalDetailsStep
  );
  const selectedTravelerIds = useSelector(
    ActivityTravelerSelectors.getSelectedTravelerIds
  );
  const expState = useExperiments();
  const isCheckoutImprovementsAvailable = isCheckoutImprovementsEnabled(
    expState.experiments
  );
  const isSinglePrimaryTraveler =
    isCheckoutImprovementsAvailable && selectedTravelerIds.length === 1;

  return [
    {
      name: "Traveler information",
      status: (() => {
        switch (parentState) {
          case ParentState.activityTravelerInformation:
          case ParentState.passport:
          case ParentState.contactInformation:
          case ParentState.loading:
            return 1;
          default:
            return 2;
        }
      })(),
    },
    !isSinglePrimaryTraveler && {
      name: "Primary traveler",
      status: (() => {
        switch (parentState) {
          case ParentState.activityTravelerInformation:
          case ParentState.passport:
          case ParentState.contactInformation:
          case ParentState.loading:
            return 0;
          case ParentState.activityPrimaryTraveler:
            return 1;
          default:
            return 2;
        }
      })(),
    },
    hasAdditionalDetailsStep && {
      name: "Additional details",
      status: (() => {
        switch (parentState) {
          case ParentState.activityTravelerInformation:
          case ParentState.passport:
          case ParentState.contactInformation:
          case ParentState.loading:
          case ParentState.activityPrimaryTraveler:
            return 0;
          case ParentState.activityAdditionalDetails:
            return 1;
          default:
            return 2;
        }
      })(),
    },
    {
      name: "Rewards & payment",
      status: (() => {
        switch (parentState) {
          case ParentState.activityTravelerInformation:
          case ParentState.passport:
          case ParentState.contactInformation:
          case ParentState.loading:
          case ParentState.activityPrimaryTraveler:
          case ParentState.activityAdditionalDetails:
          case ParentState.cartQuote:
            return 0;
          case ParentState.cardPayment:
            return 1;
          default:
            return 2;
        }
      })(),
    },
  ].filter((step) => !!step) as CheckoutStepperProps["steps"];
};
